import React, { Component } from 'react';
import { AiOutlineHome, AiOutlineMenu, AiOutlineSecurityScan, AiOutlineSolution, AiOutlineMedicineBox, AiOutlineDollar } from "react-icons/ai";
import MultilevelSidebar from "react-multilevel-sidebar";
import "react-multilevel-sidebar/src/Sidebar.css";
import { Link, withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { HttpService } from '../library';
import { ShowDialogContainer } from '../library/common/ShowDialog';
import { hasReadPermission, hasPaystubPermission } from '../service/userService';
import TrailbossFooter from "./DashboardComponent/footer/Footer";

class Layout extends Component {
    constructor(props: any) {
        super(props)
        this.state = {
            openCMS: false,
            //menuItems : []
            menuItems: []
        };
    }

    handleSidebarCMSToggle = (elem: any) => {
        this.setState({
            openCMS: elem
        })
    };

    handleClick = (itemOptions: any) => {
        if (itemOptions.href) {
            if (itemOptions.EventTarget == '_blank') {
                window.open(itemOptions.href, '_blank');
            }

            else if (itemOptions.href.includes('http://') || itemOptions.href.includes('https://')) {
                window.open(itemOptions.href, '_blank');
            }

            else {
                this.props.history.push({
                    pathname: itemOptions.href
                });
            }

            this.setState({
                openCMS: false
            })
        }
    }

    logoSidebarMenu = () => {
        return (
            <div className="logoDashboardSidebarWrapper">
                <Link to="/">
                    <img src={setting.cdnUrl + '/assets/images/logo/logo_trailboss.png'} className="logoDashboardSidebar" />
                </Link>
            </div>
        )
    }
    componentDidMount = () => {
        this.getMenus();
    }
    convertUrlToBlob = async (url: string) => {
        await fetch(url).then(r => r.blob());
    }
    getMenus = async () => {
        await HttpService.get("Menu/MenuList").then((response) => {
            var menus: any = [];
            menus.push({
                content: [
                    {
                        id: 100,
                        name: 'Home',
                        icon: <AiOutlineHome />,
                        href: '/dashboard-advantage',
                        securityObject: hasReadPermission('Advantage.Dashboard'),
                    }
                ]
            });
            if (response.data) {
                var allMenus = response.data;
                allMenus.map((menu: any, key: any) => {
                    let actionlink = null;
                    if (menu.Application != null) {
                        if (menu.Application.Type.includes('Internal') || menu.Application.Type.includes('Local')) {
                            actionlink = (window.location.href + menu.Application.Action).replace(/([^:]\/)\/+/g, '$1');
                        }
                        else if (menu.Application.Type.includes('External')) {
                            actionlink = menu.Application.Action;
                        }
                        else {
                            if (menu.Application.File != undefined) {
                                actionlink = menu.Application.File.FileUrl;
                            } else {
                                actionlink = null;
                            }
                        }
                    }
                    else if (menu.IsFormMenu) {
                        actionlink = window.location.href + "forms?menuId=" + menu.MenuId + '&form=' + menu.Name;
                    }
                    menus.push({
                        content: [
                            {
                                id: menu.MenuId,
                                name: menu.Name,
                                icon: <i className={menu.IconClass}></i>,
                                href: actionlink,
                                EventTarget: "_blank",
                                securityObject: menu.SecurityObject ? hasReadPermission(menu.SecurityObject.Name) : false,
                            }
                        ]
                    });

                })
            }

            menus.push({
                content: [
                    {
                        id: 100,
                        name: 'Deduction & Contribution report',
                        icon: <AiOutlineSolution />,
                        href: '/report-deduction',
                        securityObject: hasReadPermission('Advantage.DeductionContributionReport'),
                    }
                ]
            },
                {
                    content: [
                        {
                            id: 101,
                            name: 'Medical summary report',
                            icon: <AiOutlineMedicineBox />,
                            href: '/medical-deduction',
                            securityObject: hasReadPermission('Advantage.MedicalDeduction'),
                        }
                    ]
                },
                //{
                //    content: [
                //        {
                //            id: 101,
                //            name: 'Pay stub report',
                //            icon: <AiOutlineDollar />,
                //            href: '/pay-stub',
                //            securityObject: hasReadPermission('Advantage.PayStub') && hasPaystubPermission(),
                //        }
                //    ]
                //},
                {
                    content: [
                        {
                            id: 103,
                            name: 'Contact IT Department',
                            icon: <AiOutlineSecurityScan />,
                            href: '/contact-it',
                            securityObject: hasReadPermission('Advantage.ContactIT'),
                        }
                    ]
                },
                {
                    content: [
                        {
                            id: 104,
                            name: 'Paystub Configuration',
                            icon: <AiOutlineDollar />,
                            href: '/paystub-configuration',
                            securityObject: hasReadPermission('Advantage.PaystubConfiguration'),
                        }
                    ]
                },
                {
                    content: [
                        {
                            id: 102,
                            name: 'Security',
                            icon: <AiOutlineSecurityScan />,
                            href: setting.securityWebUrl,
                            EventTarget: "_blank",
                            securityObject: hasReadPermission('Security'),
                        }
                    ]
                },
            );

            var filterdMenu = menus.filter(x => x.content[0].securityObject == true);
            this.setState({ menuItems: filterdMenu });
        }).catch((error) => {
            console.log(error);
        })
    }

    public render() {
        return (
            <>
                <section id="DashboardWrapper">
                    <ToastContainer />
                    <ShowDialogContainer />
                    <div className="DashboardWrapperChild">
                        <div className="sidebarPanel">
                            <div className="logoWrapper">
                                <Link to="/">
                                    <img src={setting.cdnUrl + '/assets/images/logo/logo_trailboss.png'} className="logoDashboard" />
                                </Link>
                            </div>
                            <div className="menuWrapper">
                                <MultilevelSidebar
                                    persist={this.state.openCMS}
                                    open={this.state.openCMS}
                                    onToggle={() => this.handleSidebarCMSToggle()}
                                    options={this.state.menuItems}
                                    header={this.logoSidebarMenu()}
                                    onItemClick={this.handleClick}
                                />
                                <div onClick={() => this.handleSidebarCMSToggle(true)} className="MenuOpenIcon" title="Sidebar Menu">
                                    <AiOutlineMenu size="20" color="#fff" />
                                </div>
                            </div>
                        </div>

                        <React.Fragment>
                            {this.props.children}
                        </React.Fragment>

                    </div>
                </section>
                <TrailbossFooter />
            </>
        );
    }
}

export default withRouter(Layout);